import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { FaChevronDown, FaSearch } from "react-icons/fa";

const TemplateSearch = ({
  modes = [],
  selectedMode,
  onModeChange,
  data = [],
  onSelectItem,
  selectedValue = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0 });
  const wrapperRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setFilteredOptions(
      data.filter((item) =>
        item.toLowerCase().includes(selectedValue.toLowerCase())
      )
    );
  }, [selectedValue, data]);

  // Detect outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        !wrapperRef.current.contains(e.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Calculate dropdown position when opening
  const handleFocus = () => {
    if (wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setDropdownPos({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
    setIsOpen(true);
  };

  return (
    <div ref={wrapperRef} className="relative w-full max-w-[clamp(200px,30vw,400px)]">
      <div className="flex items-center border border-[#D0D5DD] rounded-md bg-white dark:bg-acs-dark-surface overflow-hidden">
        <div className="relative flex items-center border-r border-[#D0D5DD] px-fluid-2">
          <select
            value={selectedMode}
            onChange={(e) => onModeChange(e.target.value)}
            className="appearance-none text-fluid-sm font-semibold text-[#1D2939] bg-transparent focus:outline-none pr-5 cursor-pointer"
          >
            {modes.map((mode, idx) => (
              <option key={idx} value={mode}>
                {mode}
              </option>
            ))}
          </select>
          <FaChevronDown className="absolute right-fluid-1 top-1/2 -translate-y-1/2 text-[#1D2939] w-fluid-icon-xs h-fluid-icon-xs pointer-events-none" />
        </div>
        {/* Right Search Input */}
        <div className="relative flex-1 flex items-center px-fluid-input-x py-fluid-input-y">
          <input
            type="text"
            value={selectedValue}
            onChange={(e) => onSelectItem(e.target.value)}
            onFocus={handleFocus}
            placeholder={`Search ${selectedMode}...`}
            className="w-full text-fluid-sm text-[#344054] placeholder-[#9DA8BB] bg-transparent dark:text-acs-dark-text focus:outline-none"
          />
          <FaSearch className="absolute right-fluid-1 top-1/2 -translate-y-1/2 text-[#344054] dark:text-acs-dark-text w-fluid-icon-sm h-fluid-icon-sm pointer-events-none" />
        </div>
      </div>

      {/* Portal Dropdown */}
      {isOpen && filteredOptions.length > 0 &&
        createPortal(
          <>
            <style>{`
              @keyframes ha-in-right {
                from { opacity: 0; transform: translateX(10px); }
                to { opacity: 1; transform: translateX(0); }
              }
              .ha-dropdown { animation: ha-in-right 200ms ease-out both; }
            `}</style>

            <div
              ref={dropdownRef}
              style={{
                position: "absolute",
                top: dropdownPos.top + 5,
                left: dropdownPos.left,
                width: dropdownPos.width,
                zIndex: 9999,
              }}
              className="ha-dropdown fixed z-[9999]
                         border border-gray-200 dark:border-acs-dark-border
                         rounded-md shadow-lg
                         bg-white dark:bg-acs-dark-bg
                         max-h-[200px] overflow-y-auto"
            >
              <div className="flex flex-col p-fluid-2">
                {filteredOptions.map((item) => (
                  <button
                    key={item}
                    onClick={() => {
                      onSelectItem(item);
                      setIsOpen(false);
                    }}
                    className="flex items-center gap-fluid-1
                               w-full text-left
                               px-fluid-3 py-fluid-1.5
                               text-gray-600 dark:text-acs-dark-text
                               text-fluid-xs sm:text-fluid-sm
                               hover:bg-gray-50 dark:hover:bg-[#1f222a]
                               transition-colors rounded-md"
                  >
                    <span className="truncate">{item}</span>
                  </button>
                ))}
              </div>
            </div>
          </>,
          document.body
        )}
    </div>
  );
};

export default TemplateSearch;
